export default "__VITE_ASSET__CUq0wlmH__"